module.exports = __webpack_public_path__ + "img/right.9a26bb7e.png";